module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/common/styles/font/MaterialIcons-Regular.ttf
// module id = 2013
// module chunks = 2